<template>
  <div class="info right-fade-in">
    <div class="info__head">
      <span class="text-main heading">Information</span>
      <a @click="$emit('close')">
        <GjIcon
          name="Close"
          class="close"
        />
      </a>
    </div>
    <div class="info__body">
      <p
        class="text-main text-medium info-title"
      >
        {{ title || info.title }}
      </p>
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="info-message"
        v-html="message || info.message"
      />
      <!--eslint-enable-->
    </div>
  </div>
</template>
<script>
export default {
  name: 'Info',
  props: {
    info: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables/variables';

.info {
  word-break: break-word;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1111;
  width: 280px;
  background-color: $white;
  box-shadow: -2px 0px 16px rgba(5, 45, 97, 0.08);

  .heading {
    font-size: 16px;
  }

  &__head {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    background-color: $gray-123;
  }
  .close {
    color: $blue-800;
  }

  &__body {
    padding: 24px 16px;
  }
}

.right-fade-in {
  animation: fadeRightIn 0.5s;
  -webkit-animation: fadeRightIn 0.5s;
  -moz-animation: fadeRightIn 0.5s;
  -o-animation: fadeRightIn 0.5s;
  -ms-animation: fadeRightIn 0.5s;
}

@keyframes fadeRightIn {
  0% {
    opacity: 0;
    transform: translateX(2%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@-moz-keyframes fadeRightIn {
  0% {
    opacity: 0;
    transform: translateX(2%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@-webkit-keyframes fadeRightIn {
  0% {
    opacity: 0;
    transform: translateX(2%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@-o-keyframes fadeRightIn {
  0% {
    opacity: 0;
    transform: translateX(2%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@-ms-keyframes fadeRightIn {
  0% {
    opacity: 0;
    transform: translateX(2%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
